import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class NotificationErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Notification Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <NotificationErrorFallback />;
    }

    return this.props.children;
  }
}

const NotificationErrorFallback: React.FC = () => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <Box sx={{ p: 2, textAlign: 'center' }}>
      <Typography variant="body2" color="error" gutterBottom>
        Failed to load notifications
      </Typography>
      <Button
        startIcon={<RefreshIcon />}
        size="small"
        onClick={handleRetry}
      >
        Retry
      </Button>
    </Box>
  );
};

export default NotificationErrorBoundary;

